import { defineComponent, openBlock, createBlock, unref, withCtx, renderSlot, createElementBlock, Fragment, renderList } from "vue";
import GenericDropdown from "../../GenericDropdown/GenericDropdown.mjs";
const _hoisted_1 = ["id", "value", "selected", "innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxSkuSelector",
  props: {
    error: {
      type: Boolean
    },
    label: {},
    selectedSku: {
      default: () => ({})
    },
    skus: {}
  },
  emits: ["registerRef", "skuSelectUpdate"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleRef = (ref) => {
      emit("registerRef", {
        type: "sku",
        value: ref
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(GenericDropdown), {
        ref: "skuDropdown",
        "default-selected": !_ctx.selectedSku.skuId,
        error: _ctx.error,
        label: _ctx.label,
        "select-id": "size-dropdown",
        onUpdate: _cache[0] || (_cache[0] = (e) => _ctx.$emit("skuSelectUpdate", e.target.value)),
        onEmitRef: _cache[1] || (_cache[1] = (data) => handleRef(data))
      }, {
        default: withCtx(() => [renderSlot(_ctx.$slots, "link"), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.skus, (opt) => {
          return openBlock(), createElementBlock("option", {
            id: opt.value,
            key: opt.label,
            value: opt.value,
            selected: _ctx.selectedSku.skuId === opt.value,
            innerHTML: opt.label
          }, null, 8, _hoisted_1);
        }), 128))]),
        _: 3
      }, 8, ["default-selected", "error", "label"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxSkuSelector.mjs.map
